"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFractions = void 0;
/**
 * Sum two numbers with fractions.
 * @public
 *
 * @param a - The first number.
 * @param b - The second number.
 *
 * @returns The sum of the two numbers.
 *
 * @example
 * ```ts
 * const result = addFractions(1.1, 2.2);
 * console.log(result);
 * // -> 3.3
 * ```
 */
function addFractions(a, b) {
    return Math.round((a + b) * 1e12) / 1e12;
}
exports.addFractions = addFractions;
//# sourceMappingURL=add-fractions.js.map